export default class Comment extends Backbone.Model
  defaults:
    children: []
    resolved: 0
    active: false,
    author_is_employee: false,
    author_is_managing_editor: false

  urlRoot: ->
    if window.story.remote
      "/stories/#{@get('story_id')}/comments/remote_approver_comments"
    else
      "/stories/#{@get('story_id')}/comments"

  validate: (attrs, options) ->
    return "Please leave a comment." if attrs.body.length < 1

  markThreadRead: ->
    $.post(@url() + "/thread_read")
      .done (data, textStatus, jqXHR) =>
        _.each @get("children"), (reply) ->
          _.extend(reply, {read: true, unread: true})
        @set(read: true, thread_read: true)

  resolve: (callbacks) ->
    if window.story.remote
      url = @urlRoot() + "/#{@get('id')}/resolve/"
    else
      url = @urlRoot() + "/resolved/#{@get('id')}"

    $.ajax
      type: "PUT"
      data: {
        comment: { resolved: 1 },
        remote_approver_comment: { resolved: 1 },
        token: window.story.remote_token
      }
      url: url
      success: ->
        callbacks.success() if callbacks.success
      error: =>
        @set(resolved: 0)
        contently.flash.alert "There was an error resolving your comment, please try again."

  isVideo: -> @get("start_time")?
  isImage: -> @get("shape")? && !@get("start_time")?
  isText: -> @get("mark_id")?
  isResolved: -> @get("resolved") == 1
  isActive: -> @get("active")

  belongsToAsset: (asset) ->
    @get("asset_id")? && @get("asset_id").toString() == asset.get("asset_id").toString()

  isAnnotatable: (asset) ->
    (@isVideo() || @isImage()) && @belongsToAsset(asset) && !@isResolved()

  isInlineAnchored: ->
    markId = @get('mark_id')
    $("mark[data-mark-id='#{markId}']").length > 0

  isVideoAnchored: ->
    assetId = @get('asset_id')
    $("video[data-asset-id='#{assetId}']").length > 0

  isImageAnchored: ->
    assetId = @get('asset_id')
    $("img[data-asset-id='#{assetId}']").length > 0

  toVideoAnnotation: ->
    {
      id: @get("id"),
      range: {
        start: @get("start_time"),
        end: @get("end_time")
      },
      shape: @get("shape"),
      comments: []
    }

  toImageAnnotation: ->
    { id: @get("id"), shape: @get("shape") }

  selectedTextChanged: (currentText) ->
    @get("highlighted_text") != currentText



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/models/comment.js.coffee